<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-file"></i> {{ _('Transactions') }}</h3>
        </div>
      </div>
      <div class="list-filter-row">
        <div class="list-filter-col filtercol">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" :class="'btn btn-info hidden-col-sm hidden-col-md hidden-col-lg' + (listFilterVisible ? ' active' : '')" :title="(listFilterVisible ? 'Piilota rajaimet' : 'Näytä rajaimet')" @click="listFilterVisible = !listFilterVisible"><i :class="'fa fa-fw ' + (listFilterVisible ? 'fa-caret-up' : 'fa-sliders')"></i></button>
                <button type="button" :class="'hidden-col-xs btn btn-success'" :title="_('Search')"><i class="fa fa-fw fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>
        <div v-if="listFilterVisible" class="list-filter-col filtercol">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">{{ _('Display') }}</div>
              <select class="form-control" id="invoiceTypeFilter" v-model="type">
                <option value="all">{{ _('Select...') }}</option>
                <option value="notpaid">{{ _('Unpaid items') }}</option>
                <option value="paid">{{ _('Paid items') }}</option>
                <option value="refunded">{{ _('Refunded items') }}</option>
                <option value="refunds">{{ _('Refunds') }}</option>
                <option value="withmore">{{ _('Invoices with additional info') }}</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="listFilterVisible" class="list-filter-col button-col filtercol">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">{{ _('Filter') }}</div>
              <select class="form-control" id="invoiceRangeFilter" v-model="range">
                <option class="rangeOption" value="all">{{ _('No filter') }}</option>
								<optgroup :label="_('By POS')" v-if="poses && poses.length">
                  <option class="posOption" :value="'pos-' + pos.id" v-for="pos in poses">{{ pos.name }}</option>
                  <option class="posOption" value="allpos">{{ _('All POS transactions') }}</option>
                  <option class="posOption" value="nopos">{{ _('No POS transactions') }}</option>
								</optgroup>
              </select>
            </div>
          </div>
        </div>
        <div v-if="listFilterVisible" class="list-filter-col button-col filtercol">
          <select class="form-control" id="dateRangeSelectFilter" v-model="dateRangeSelectFilter">
            <option class="rangeOption" value="">{{ _('Select date range') }}</option>
            <optgroup :label="_('By time range')">
              <option class="rangeOption" value="lastweek">{{ _('Last week') }}</option>
              <option class="rangeOption" value="lastmonth">{{ _('Last month') }}</option>
              <option class="rangeOption" value="lastyear">{{ _('Last year') }}</option>
              <option class="rangeOption" value="exact">{{ _('Select exact date range') }}</option>
              <option class="rangeOption" value="all">{{ _('All transactions') }}</option>
            </optgroup>
          </select>
        </div>
        <div class="list-filter-col filtercol" v-if="showExactRange && listFilterVisible">
          <div class="rangeFields">
            <div class="form-inline">
              <div class="form-group">
                <DatePicker v-model="dateStart" :max-date="dateEnd" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
              </div>
              <label for="endDate"> - </label>
              <div class="form-group">
                <DatePicker v-model="dateEnd" :min-date="dateStart" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
              </div>
            </div>
          </div>
        </div>
        <div v-if="listFilterVisible" class="list-filter-col button-col filtercol">
          <button class="btn btn-success" type="button" v-on:click="downloadXlsx"><i class="fa fa-fw fa-download"></i> {{ _('Download Excel file') }}</button>
        </div>
      </div>
      <Datatable :url="invoicesUrl" :search="search" :type-filter="type" :pos-filter="pos" :invoice-date-filter="dateRangeFilter" :options="tableOptions" ref="datatable" v-on:data="tableEvent" />
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { DateTime } from 'luxon'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import Datatable from '~/components/Datatable'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      invoices: [],
      showExactRange: false,
      dateStart: false,
      dateEnd: false,
      search: '',
      type: 'all',
      range: 'all',
      dateRangeValue: '',
      poses: [],
      tableOptions: {
        rowFormatter: $this.orderRowFormatter(),
        responsiveLayoutCollapseFormatter: $this.collapseFormatter(),
        columns: [
        {
          title: _('No.'),
          field: 'id',
          width: 100,
          responsive: 0
        },
        {
          title: _('Payer'),
          field: 'name',
          widthGrow: 4,
          formatter: $this.orderCustomerFormatter(),
          responsive: 0
        },
        {
          title: _('Total'),
          field: 'totalWithDelivery',
          widthGrow: 2,
          formatter: $this.numberFormatter(),
          hozAlign: 'right'
        },
        {
          title: _('Status'),
          field: 'paid',
          width: 110,
          formatter: $this.orderPaidFormatter()
        },
        {
          title: _('Payment method'),
          field: 'payment',
          widthGrow: 2,
          formatter: $this.paymentFormatter()
        },
        {
          title: _('Ref. no.'),
          field: 'refnumber',
          widthGrow: 1
        },
        {
          title: _('Invoice date'),
          field: 'invoicedate',
          widthGrow: 1,
          formatter: $this.dateFormatter()
        },
        {
          title: _('Due date'),
          field: 'duedate',
          widthGrow: 1,
          formatter: $this.dateFormatter()
        },
        {
          title: _('Payment date'),
          field: 'paymentdate',
          widthGrow: 1,
          formatter: $this.dateFormatter()
        },
        ],
        initialSort: [{
          column: 'id',
          dir: 'desc'
        }],
        rowClick (e, row) {
          $this.editRow(row)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    invoicesUrl () {
      return this.baseDomain + this.shopId + '/bills.json?apikey=' + this.apiKey + '&rawformat=true'
    },
    dateRangeSelectFilter: {
      get () {
        if(this.showExactRange) {
          return 'exact'
        }
        if(this.dateRange === '') {
          return ''
        }
        return this.dateRange
      },
      set (newValue) {
        if (!newValue || !newValue.match || !newValue.match('-')) {
          this.showExactRange = false
          this.dateStart = false
          this.dateEnd = false
          this.dateRange = newValue
          return
        }
        this.setExactRangeFromFilter(newValue)
      }
    },
    dateRangeFilter: {
      get () {
        if (this.dateStart && this.dateEnd) {
          return DateTime.fromJSDate(this.dateStart, { zone: this.timezone }).toFormat('d.M.yyyy') + '-' + DateTime.fromJSDate(this.dateEnd, { zone: this.timezone }).toFormat('d.M.yyyy')
        }
        return this.dateRange
      },
      set (newValue) {
        if (!newValue || !newValue.match || !newValue.match('-')) {
          this.showExactRange = false
          this.dateStart = false
          this.dateEnd = false
          this.dateRange = newValue
          return
        }
        this.setExactRangeFromFilter(newValue)
      }
    },
    pos: {
      get () {
        if (this.range && this.range.match(/pos-/)) {
          const pArr = this.range.split('-')
          return pArr[1]
        }
        if (this.range === 'allpos' || this.range === 'nopos') {
          return this.range
        }
        return ''
      },
      set (newValue) {
        if (newValue) {
          if (newValue === 'allpos' || newValue === 'nopos') {
            this.range = newValue
          } else {
            this.range = 'pos-' + newValue
          }
        }
      }
    },
    dateRange: {
      get () {
        switch (this.dateRangeValue) {
          case 'lastweek':
          case 'lastmonth':
          case 'lastyear':
          case 'exact':
            return this.dateRangeValue
        }
        return ''
      },
      set (newValue) {
        switch (newValue) {
          case 'lastweek':
          case 'lastmonth':
          case 'lastyear':
            this.dateRangeValue = newValue
            break
          case 'exact':
            if(!this.showExactRange) {
              this.showExactRange = true
            }
            this.dateRangeValue = newValue
          case '':
          case 'all':
            this.dateRangeValue = ''
            break
        }
      }
    }
  },
  methods: {
    downloadXlsx () {
      const filters = []
      if (this.search) {
        filters.push({ field: 'search', type: 'like', value: this.search })
      }
      if (this.type) {
        filters.push({ field: 'type', type: '=', value: this.type })
      }
      if (this.pos) {
        filters.push({ field: 'pos_name', type: '=', value: this.pos })
      }
      if (this.dateRangeFilter) {
        filters.push({ field: 'invoicedate', type: '=', value: this.dateRangeFilter })
      }
      let filterStr = ''
      if (filters.length) {
        filterStr = '&filters[]=' + filters.map(f => JSON.stringify(f)).join('&filters[]=')
      }
      window.open(this.baseDomain + this.shopId + '/bills.xlsx?apikey=' + this.apiKey + filterStr)
    },
    editRow (row) {
      let id = row.getCell('id').getValue()
      let name = row.getCell('name').getValue()
      if (!name) {
        const d = row._row.data
        if (d.pos_name) {
          name = d.pos_name
        } else {
          name = this._('Transaction incomplete')
        }
      }
      this.editInvoice(id, name)
    },
    editInvoice (id, name, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'InvoiceDetails',
        title: this._('Transaction') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          invoiceId: id
        },
        skipState
      })
    },
    reload () {
      this.$refs.datatable.reload()
    },
    async loadPoses () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/pos.json?version=' + this.locale + '&iSortCol_0=1&sSortDir_0=asc&iSortingCols=1&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.poses = response.data
    },
    selectRange () {
      this.showExactRange = true
    },
    unselectRange () {
      this.showExactRange = this.dateStart = this.dateEnd = false
    },
    inputDateStart (newValue) {
      this.dateStart = newValue
    },
    inputDateEnd (newValue) {
      this.dateEnd = newValue
    }
  },
  components: {
    Datatable
  },
  watch: {
    listFilterVisible () {
      this.$refs.datatable.resize()
    }
  },
  mounted () {
    this.loadPoses()
    if(!this.events) {
      let events = {}
      events['billUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      events['restoreDetails'] = (message) => {
        if (message.shopId !== this.shopId) {
          return
        }
        switch(message.component) {
          case 'InvoiceDetails':
            this.editInvoice(message.data.invoiceId, null, true)
            break
        }
      }
      events['setInvoiceListParams'] = (message) => {
        if (message) {
          if (message.type) {
            this.type = message.type
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>